import { render } from "./TrainingRncpAccordionActivitiesComponent.vue?vue&type=template&id=d3663e70&scoped=true"
import script from "./TrainingRncpAccordionActivitiesComponent.vue?vue&type=script&lang=js"
export * from "./TrainingRncpAccordionActivitiesComponent.vue?vue&type=script&lang=js"

import "./TrainingRncpAccordionActivitiesComponent.vue?vue&type=style&index=0&id=d3663e70&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3663e70"]])

export default __exports__